// src/utils/request.js - 无需配置文件版本
import axios from 'axios';

// ==========================================
// 配置项 - 直接写在这里
// ==========================================
// const API_BASE_URL = 'https://shouyintaiapi.bdsplay.com';  // ← 稚哥
const API_BASE_URL = 'https://aliyiaapi.wmyth.com';  // ← 萍

const request = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
request.interceptors.request.use(
  config => {
    console.log('📡 发送请求:', {
      method: config.method?.toUpperCase(),
      url: config.url,
      baseURL: config.baseURL,
      fullURL: config.baseURL + config.url
    });
    
    // 添加 token
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  error => {
    console.error('❌ 请求拦截器错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  response => {
    console.log('✅ 收到响应:', {
      status: response.status,
      url: response.config.url,
      data: response.data
    });
    
    return response.data;
  },
  error => {
    console.error('❌ 响应错误:', {
      message: error.message,
      url: error.config?.url,
      status: error.response?.status,
      data: error.response?.data
    });
    
    // 401 未授权
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

export default request;